module.exports = __webpack_public_path__ + "img/message.89c38a15.svg";